/**
 * VroongLogo Components
 * VROONG 브랜드 로고
 */
import React from "react";

interface VroongLogoProps {
    width?: number;
    height?: number;
}

export const VroongLogo: React.FC<VroongLogoProps> = ({
    width = 120,
    height = 40
}) => (
    <svg width={width} height={height} viewBox="0 0 120 40" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" style={{ stopColor: '#05CD82', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#0091FF', stopOpacity: 1 }} />
            </linearGradient>
        </defs>
        <text
            x="10"
            y="28"
            fontFamily="Inter, sans-serif"
            fontSize="24"
            fontWeight="800"
            fill="url(#logoGradient)"
        >
            VROONG
        </text>
    </svg>
);

export default VroongLogo;
